import { useRef, useState } from "react"
import QRCode from "qrcode"
import { Button, Box, TextField } from "@mui/material"
import { createTotpURI, verifyTotpToken } from "./services/cloudFunctions"

const QrTest = () => {
  const imgRef = useRef()

  const [enteredToken, setEnteredToken] = useState("")

  const handleVerifyToken = async () => {
    console.log("verify", enteredToken)
    const verified = await verifyTotpToken(enteredToken)
    console.log(verified)
  }

  const handleTokenChange = (e) => {
    setEnteredToken(e.target.value)
  }

  const handleGenerateQRCode = async () => {
    const totpResult = await createTotpURI("greg55@ozemail.com.au")
    console.log("uri", totpResult)

    const url = totpResult.data.uri

    QRCode.toDataURL(url, { errorCorrectionLevel: "L" }).then((url) => {
      console.log(url)

      imgRef.current.src = url
    })
  }

  return (
    <Box>
      <Box>
        <Button onClick={handleGenerateQRCode}>Generate</Button>
      </Box>
      <Box>
        <img alt="QRCode" ref={imgRef} />
      </Box>
      <Box>
        <TextField label="Token" onChange={handleTokenChange} />
        <Button onClick={handleVerifyToken}>Verify</Button>
      </Box>
    </Box>
  )
}

export default QrTest
